<template>
  <div class="container hasBG challenges flexbox">
    <div class="competition_subject competition_exam challenges" v-if="dataReady && questions.length > 0">
      <div class="title">
        <div class="header">
          <div class="header_left">
            <div class="subject_type">{{currentQuestion.questionmode}}</div>
            <p>题卷共{{questions.length}}题</p>
          </div>
          <div class="subject_time">
            <span>倒计时:</span><van-count-down ref="time" :time="maxTime" format="mm:ss" @finish="timeEnd" />
          </div>
        </div>
        <div class="subject_title">
          <p>第{{currentIndex + 1}}题：</p>
          <p>{{currentQuestion.questionname}}</p>
        </div>
      </div>
      <div class="option">
        <h4>答案选项</h4>
        <div class="option_item">
          <div
            class="option_list van-hairline--surround"
            v-for="option in currentQuestion.examquestionSelectorList"
            :key="option.id"
            :class="{
              'selected': answerSheet[currentIndex].answerselector.indexOf(option.selectorname) > -1
            }"
            @click="selectAnswer(option.selectorname, currentQuestion.id, currentQuestion.questiontype)"
          >
            <div
              class="van-hairline--surround"
              :class="{'option-checkbox': currentQuestion.questiontype, 'option-radio': !currentQuestion.questiontype}"
            >
              {{option.selectorname}}
            </div>
            <div class="option-content">{{option.content}}</div>
          </div>
        </div>
        <div class="subject_btn">
          <!-- <van-button @click="prev">上一题</van-button> -->
          <van-button v-if="currentIndex !== answerSheet.length - 1" @click="next">下一题</van-button>
          <van-button v-if="currentIndex === answerSheet.length - 1" :disabled="submiting" @click="submitAnswer">提交</van-button>
        </div>
      </div>
    </div>
    <p class="tips" v-if="dataReady">技术支持：广东科技报   广州市乾润信息技术有限公司</p>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  import throttle from 'lodash/throttle'
  import $ from 'jquery'
  const u = navigator.userAgent
  export default {
    name: 'challengesExamList',
    data () {
      return {
        maxTime: 0,
        questions: [],
        answerSheet: [],
        currentIndex: 0,
        dataReady: false,
        startTime: '',
        submiting: false
      }
    },
    computed: {
      currentQuestion: function() {
        // console.log(this.questions[this.currentIndex])
        return this.questions[this.currentIndex]
      }
    },
    created () {
      this.$toast.allowMultiple()
      this.$fetch.get(API.NATURECONTESTEXAMQUESTIONLIST, {
        examid: this.$route.query.id
      }).then(response => {
        // console.log(response)
        var _this = this
        if (response.status !== 200) {
          var message = response.message ? response.message : '题目获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        var start = response.data.starttime.replace(/-/g, '/')
        var end = response.data.endtime.replace(/-/g, '/')
        // console.log(new Date(end).getTime() > new Date().getTime())
        if (new Date(start).getTime() > new Date().getTime()) {
          this.$dialog.alert({
            message: '竞赛尚未开始！'
          }).then(() => {
            _this.$router.replace('/challenges/index')
          })
          return
        }
        if (new Date(end).getTime() < new Date().getTime()) {
          this.$dialog.alert({
            message: '很抱歉~~竞赛已经结束！'
          }).then(() => {
            _this.$router.replace('/challenges/index')
          })
          return
        }
        if (response.data.status === 1) {
          this.$dialog.alert({
            message: '请先登记信息再进行答题',
          }).then(() => {
            _this.$store.commit('savecompetitionid', {id: 'tab'})
            _this.$router.replace('/challenges/index')
          })
          return
        } else if (response.data.status === 2) {
          this.$dialog.alert({
            message: '今日答题次数已用完，明天再来吧',
          }).then(() => {
            _this.$router.push('/challenges/index')
          })
          return
        }
        this.dataReady = true
        if (response.data.examQuestionList.length === 0) {
          this.$toast({
            message: '暂无题目',
            duration: 0
          })
          return
        }
        document.title = response.data.examname
        this.maxTime = response.data.oneminute * 1000
        this.questions = response.data.examQuestionList
        this.questions.forEach(function(item){
          _this.answerSheet.push({
            id: item.id,
            answerselector: ''
          })
        })
      }).catch(error => {
        console.log(error)
      })
    },
    mounted () {
      var date = new Date()
      this.startTime = date.getTime()
      // console.log(this.startTime)
      // document.title = this.$store.state.title
    },
    methods: {
      selectAnswer (value, id, multi) {
        if (multi) {
          for (let answer of this.answerSheet) {
            if (answer.id === id) {
              let answerselector = answer.answerselector.length > 0 ? answer.answerselector.split(',') : []
              if (answer.answerselector.indexOf(value) > -1) {
                answerselector.forEach((item, index) => {
                  if (item === value) answerselector.splice(index, 1)
                })
              } else {
                answerselector.push(value)
              }
              this.$set(answer, 'answerselector', answerselector.join(','))
            }
          }
        } else {
          for (let answer of this.answerSheet) {
            if (answer.id === id) {
              this.$set(answer, 'answerselector', value)
            }
          }
          if (this.answerSheet[this.currentIndex+1] && this.answerSheet[this.currentIndex+1].answerselector === '') {
            // setTimeout(() => {
            //   this.currentIndex = this.currentIndex + 1
            // }, 200)
          }
        }
      },
      submitAnswer () {
        // var _this = this
        // for (let answer of this.answerSheet) {
        //   if (!answer.answerselector) {
        //     this.$toast.fail('请先完成所有答题再提交！')
        //     return
        //   }
        // }
        if (!this.answerSheet[this.currentIndex].answerselector) {
          this.$toast('请先选择你的答案')
        } else {
          var date = new Date()
          var endTime = date.getTime()
          var useTime = endTime - this.startTime
          this.submiting = true
          this.postAnswer(useTime)
        }
      },
      // timeOut () {
      //   this.$toast({
      //     message: '考试时间已结束，系统将会为您自动提交！',
      //     forbidClick: true,
      //     overlay: true,
      //     duration: 3000
      //   })
      //   var _this = this
      //   setTimeout(function(){
      //     _this.postAnswer(_this.maxtime)
      //   }, 3000)
      // },
      postAnswer: throttle(function(time){
        var _this = this
        const load = this.$toast({
          type: 'loading',
          duration: 0,
          loadingType: 'spinner',
          forbidClick: true
        })
        this.$fetch.post(API.NATURECONTESTEXAMANSWER, {
          examid: this.$route.query.id,
          examjson: JSON.stringify(this.answerSheet),
          answertime: Math.round(time/1000)
        }).then(response => {
          // console.log(response)
          load.clear()
          if (response.status !== 200) {
            this.submiting = false
            this.$toast.fail(response.message)
            return
          }
          this.$toast.success({
            message: '提交成功!',
            forbidClick: true
          })
          this.$store.commit('savecompetitionid', {id: this.$route.query.id, isdraw: response.data.isdraw})
          setTimeout(function(){
            _this.$router.replace({
              path: '/challenges/index'
            })
          }, 2000)
        }).catch(error => {
          load.clear()
          let msg = error.message ? error.message : '提交失败，请稍后尝试!'
          this.$toast.fail(msg)
          this.submiting = false
          console.log(error)
        })
      }, 3000, { 'trailing': false }),
      next() {
        if (this.currentIndex === this.questions.length-1) return
        if (!this.answerSheet[this.currentIndex].answerselector) {
          this.$toast('请先选择你的答案')
        } else {
          this.currentIndex = this.currentIndex + 1
          this.$refs.time.reset()
        }
      },
      prev() {
        if (this.currentIndex === 0) return
        this.currentIndex = this.currentIndex -1
      },
      timeEnd () {
        if (this.currentIndex === this.questions.length-1) {
          var date = new Date()
          var endTime = date.getTime()
          var useTime = endTime - this.startTime
          this.submiting = true
          this.postAnswer(useTime)
        } else {
          this.currentIndex = this.currentIndex + 1
          this.$refs.time.reset()
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      this.$dialog.close()
      this.$toast.clear()
      next()
    }
  }
</script>

<style lang="stylus">
  .competition_subject .option .option_item .selected:after
    border-color #16a6ae
  .competition_subject .option .option_item .selected .option-radio
    background-color #16a6ae
  .competition_subject .title .header .subject_type, .competition_subject .option .header .subject_type
    background-color #A9C91C
  .competition_exam .option .subject_btn .van-button
    background-color #16A6AE
</style>